import React, { useEffect, useState } from "react";
import { ThumbsUp, Heart, Star, PartyPopper } from "lucide-react";
import { FaThumbsUp, FaHeart, FaStar, FaRegLaughBeam } from "react-icons/fa";
import { Admin_Id } from "./Constant";

const defaultReactions = {
  like: 0,
  love: 0,
  wow: 0,
  celebrate: 0,
};

const lucideIconMap = {
  like: ThumbsUp,
  love: Heart,
  wow: Star,
  celebrate: PartyPopper,
};

const faIconMap = {
  like: FaThumbsUp,
  love: FaHeart,
  wow: FaStar,
  celebrate: FaRegLaughBeam,
};

const ReactionBar = ({ blogId }) => {
  const [reactions, setReactions] = useState(defaultReactions);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const fetchReactions = async () => {
      try {
        const res = await fetch(`https://100billionrealestate.com/api/reactions/slug/${blogId}`);
        const data = await res.json();
        setReactions((prev) => ({ ...prev, ...data }));
      } catch (err) {
        console.error("❌ Failed to fetch reactions:", err);
      }
    };

    if (blogId) fetchReactions();
  }, [blogId]);

  const handleReaction = async (type) => {
    setReactions((prev) => {
      const updated = { ...prev };
      if (selected && selected !== type) {
        updated[selected] = Math.max(0, updated[selected] - 1);
      }
      updated[type] = (updated[type] || 0) + 1;
      return updated;
    });

    setSelected(type);

    try {
      await fetch("https://100billionrealestate.com/api/reactions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ slug: blogId, type, AdminId: Admin_Id }),
      });
    } catch (err) {
      console.error("❌ Failed to store reaction:", err);
    }
  };

  return (
    <div className="flex gap-4 mt-4">
      {Object.keys(lucideIconMap).map((type) => {
        const LucideIcon = lucideIconMap[type];
        const FaIcon = faIconMap[type];
        const isSelected = selected === type;

        return (
          <button
            key={type}
            onClick={() => handleReaction(type)}
            aria-label={`React with ${type}`}
            className={`flex items-center gap-[2px] text-sm font-medium focus:outline-none transition-transform hover:scale-110 ${
              isSelected ? "text-red-500" : "text-gray-600"
            }`}
          >
            <div className="p-2 rounded-full bg-gray-100 hover:bg-blue-100 transition-colors">
              {isSelected ? (
                <FaIcon size={20} className="text-red-500" />
              ) : (
                <LucideIcon size={20} />
              )}
            </div>
            <span>{reactions[type]}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ReactionBar;
